export class AdminSubscriptionsToProcessDetails {
  public constructor(
    private readonly data: {
      isBulkProcessAvailable: boolean;
      itemsToProcess: number;
      nextScheduledProcessingDate: Date;
    },
  ) {}

  public get isBulkProcessAvailable(): boolean {
    return this.data.isBulkProcessAvailable;
  }

  public get itemsToProcess(): number {
    return this.data.itemsToProcess;
  }

  public get nextScheduledProcessingDate(): Date {
    return this.data.nextScheduledProcessingDate;
  }
}
